module.exports = __webpack_public_path__ + "static/media/ManualExample.5880fd53.png";